import axios from 'axios';

const {
  VUE_APP_API_BI_HOST: host,
  VUE_APP_API_BI_TOKEN: biToken,
} = process.env;

const apiBi = axios.create({
  baseURL: `${host}`,
});

apiBi.interceptors.request.use(async (config) => {
  // eslint-disable-next-line no-param-reassign
  config.headers = {
    ...config.headers,
    'X-API-Token': biToken,
  };

  return config;
}, (error) => {
  Promise.reject(error);
});

apiBi.interceptors.response.use((response) => response, (error) => {
  console.log('erroAPIBI: ', error?.response);
  if (error?.response?.status === 400) {
    throw new Error(error.response.data.error_description);
  }
  throw new Error(error);
});

export default apiBi;
